import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "station-form-category-container flex flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col justify-center bg-warning p-3 rounded"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "O médico ainda está pendente!", -1)
const _hoisted_4 = {
  key: 0,
  class: "w-full"
}
const _hoisted_5 = {
  key: 1,
  class: "w-full"
}
const _hoisted_6 = {
  key: 2,
  class: "w-full mb-2"
}
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "w-full" }

import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useDoctorStore } from '@/pinia-store/useDoctorStore'
import { mdiContentCopy } from '@mdi/js'
import { useToast } from 'vue-toastification'
import { useErrorToast } from '@/composables/useErrorToast'
import PositionService from '@/Network/Services/PositionService'
import ScheduleShiftService from '@/Network/Services/ScheduleShiftService'
import DsPaymentFormationService from '@/Network/Services/DsPaymentFormationService'


export default /*#__PURE__*/_defineComponent({
  __name: 'doctor.infos.form',
  props: {
  doctor: [String, Number],
  company: Number,
  originalDoctor: [String, Number],
  urlConviteDoctor: String,
  minimal: Boolean,
  hideDoctor: { type: Boolean, default: false },
  teamLocked: { type: Boolean, default: false },
  formation: String,
  team: String,
  position: String,
  shift: String,
  schedule: {
    type: Number,
    required: true
  },
  showFormationField: {
    type: Boolean,
    default: false
  },
  positionErr: { type: String, default: undefined },
  shiftErr: { type: String, default: undefined },
  disabled: { type: Boolean, default: false },
  configurationRepetition: { type: String, default: 'no-repeat' },
  /** Uma coluna com largura cheia (Criar plantão em tela cheia no celular, R6). */
  stacked: { type: Boolean, default: false }
},
  emits: [
  'update:doctor',
  'update:doctorName',
  'update:formation',
  'update:team',
  'update:position',
  'update:shift'
],
  setup(__props, { emit }) {

const props = __props;

const toast = useToast()
const { notifyError } = useErrorToast()





const { listDoctorsCompany } = storeToRefs(useDoctorStore())

const formations = ref<{ title: string; value: string | number }[]>([])
const positions = ref<{ title: string; value: string | number }[]>([])
const shifts = ref<{ title: string; value: string | number }[]>([])
const isLoading = ref(false)
const teams = ['Interno', 'Externo']

const doctorFilter = (itemTitle, queryText, item) => {
  const name = item.raw.title.toLowerCase()
  const crm = item.raw.subtitle.toLowerCase()
  const searchText = queryText.toLowerCase()
  return name.includes(searchText) || crm.includes(searchText)
}

const fetchDataBySchedule = async (scheduleId: number) => {
  if (!scheduleId) {
    formations.value = []
    positions.value = []
    shifts.value = []
    return
  }

  try {
    isLoading.value = true
    const [formationRes, positionRes, shiftRes] = await Promise.all([
      new DsPaymentFormationService().getByScheduleId(scheduleId),
      new PositionService().getByScheduleId(scheduleId),
      new ScheduleShiftService().getByScheduleId(scheduleId)
    ])

    formations.value = formationRes.data.map((item) => ({
      title: item.name,
      value: item.id
    }))

    positions.value = positionRes.data.map((item) => ({
      title: item.name,
      value: String(item.id)
    }))

    shifts.value = shiftRes.data.map((item) => ({
      title: item.name,
      value: String(item.id)
    }))
  } catch (e) {
    // Fallback específico do lote (formação + posição + turno): a mensagem
    // do ServiceError de quem falhou tem prioridade.
    notifyError(e, 'Não foi possível carregar formações, posições e turnos da escala')
  } finally {
    isLoading.value = false
  }
}

watch(
  () => props.schedule,
  (newVal) => {
    if (newVal) {
      fetchDataBySchedule(Number(newVal))
    } else {
      formations.value = []
      positions.value = []
      shifts.value = []
    }
  },
  { immediate: true }
)

const setFormation = (val: string) => emit('update:formation', val)
const setTeam = (val: string) => emit('update:team', val)
const setPosition = (val: string) => emit('update:position', val)
const setShift = (val: string) => emit('update:shift', val)

const copyConvite = async (e: Event) => {
  e.preventDefault()
  await navigator.clipboard.writeText(props.urlConviteDoctor || '')
  toast.success('Link copiado com sucesso')
}

const setDoctor = (doctorId: string) => {
  if (doctorId) {
    const selected = listDoctorsCompany.value.find((d) => d.value === doctorId)
    emit('update:doctor', Number(doctorId))
    emit('update:doctorName', selected?.title || '')
  } else {
    emit('update:doctor', null)
    emit('update:doctorName', '')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.urlConviteDoctor && Number(__props.originalDoctor) === Number(__props.doctor))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("a", {
            href: "",
            onClick: copyConvite,
            class: "text-sm flex justify-center items-center gap-1"
          }, [
            _createVNode(_component_v_icon, { icon: _unref(mdiContentCopy) }, null, 8, ["icon"]),
            _createTextVNode(" Clique para copiar o link do convite ")
          ])
        ]))
      : _createCommentVNode("", true),
    (!props.minimal && !props.hideDoctor)
      ? (_openBlock(), _createBlock(_component_v_autocomplete, {
          key: 1,
          "onUpdate:modelValue": setDoctor,
          items: _unref(listDoctorsCompany),
          "model-value": __props.doctor ? String(__props.doctor) : undefined,
          "custom-filter": doctorFilter,
          class: "w-full mb-4",
          color: "primary20",
          clearable: "",
          label: "Nome ou CRM do médico",
          theme: "light",
          variant: "outlined",
          density: "comfortable",
          disabled: !__props.company || props.disabled,
          "hide-details": "",
          "data-testid": "create-station-doctor-select"
        }, {
          item: _withCtx(({ props, item }) => [
            _createVNode(_component_v_list_item, _mergeProps(props, {
              title: item?.raw?.title,
              subtitle: item?.raw?.subtitle
            }), null, 16, ["title", "subtitle"])
          ]),
          _: 1
        }, 8, ["items", "model-value", "disabled"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_row, {
      dense: "",
      class: "items-end"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          "data-testid": "doctor-infos-row",
          class: _normalizeClass(["w-full flex gap-2", props.stacked ? 'flex-col' : 'justify-between'])
        }, [
          (__props.showFormationField)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_v_autocomplete, {
                  "model-value": isLoading.value ? 'Buscando...' : props.formation || undefined,
                  "onUpdate:modelValue": setFormation,
                  items: formations.value,
                  label: "Formação",
                  variant: "outlined",
                  color: "primary20",
                  clearable: "",
                  density: "comfortable",
                  "item-title": "title",
                  "item-value": "value",
                  loading: isLoading.value,
                  disabled: props.disabled
                }, null, 8, ["model-value", "items", "loading", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (props.configurationRepetition == 'no-repeat')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_v_autocomplete, {
                  "model-value": isLoading.value ? 'Buscando...' : props.position || undefined,
                  "onUpdate:modelValue": setPosition,
                  items: positions.value,
                  label: "Posição",
                  variant: "outlined",
                  color: "primary20",
                  clearable: "",
                  density: "comfortable",
                  loading: isLoading.value,
                  "error-messages": __props.positionErr,
                  disabled: props.disabled
                }, null, 8, ["model-value", "items", "loading", "error-messages", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (!props.minimal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_v_autocomplete, {
                  "model-value": isLoading.value ? 'Buscando...' : props.shift || undefined,
                  "onUpdate:modelValue": setShift,
                  items: shifts.value,
                  label: "Turno",
                  variant: "outlined",
                  color: "primary20",
                  clearable: "",
                  density: "comfortable",
                  loading: isLoading.value,
                  disabled: props.disabled,
                  "error-messages": props.shiftErr
                }, null, 8, ["model-value", "items", "loading", "disabled", "error-messages"])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          "data-testid": "doctor-infos-row",
          class: _normalizeClass(["w-full flex gap-2", props.stacked ? 'flex-col' : 'justify-between'])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_autocomplete, {
              "model-value": isLoading.value ? 'Buscando...' : props.team || undefined,
              "onUpdate:modelValue": setTeam,
              items: teams,
              label: "Time",
              variant: "outlined",
              color: "primary20",
              clearable: "",
              density: "comfortable",
              disabled: props.disabled || props.teamLocked
            }, null, 8, ["model-value", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 2)
      ]),
      _: 3
    })
  ]))
}
}

})